import { createContext } from "react";

const TranContext=createContext();

export default TranContext;